"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerContext = exports.initContext = exports.MAX_BIT_CONTEXT_VALUE = exports.BEGIN_BIT_CONTEXT_VALUE = void 0;
const Bit_1 = require("../utils/Bit");
const utils_1 = require("./utils");
exports.BEGIN_BIT_CONTEXT_VALUE = 0b1;
// max 32 context
exports.MAX_BIT_CONTEXT_VALUE = 0x80000000;
/**
 * 新建一个 bool context 桶
 * 最大可容纳 32 个 bool context
 */
const initContext = () => ({
    recordContext: 0,
    recordContextIniter: exports.BEGIN_BIT_CONTEXT_VALUE
});
exports.initContext = initContext;
/**
 * 注册一个 bool context
 * @param globalContext bool context 桶的总值
 * @returns 当前 bool context 的方法
 */
const registerContext = (globalContext) => {
    let markerContext;
    // 懒惰初始化，使 bool context 仅在设置时才被注册
    const onceInit = () => {
        if (!markerContext) {
            const contextRecordIniter = globalContext.recordContextIniter;
            if (contextRecordIniter === exports.MAX_BIT_CONTEXT_VALUE) {
                throw new RangeError('Max registered context length is 32!');
            }
            markerContext = contextRecordIniter;
            globalContext.recordContextIniter <<= 1;
        }
    };
    return {
        hasContext: () => {
            if (!(0, utils_1.isNumber)(markerContext)) {
                return false;
            }
            return (0, Bit_1.hasBitValue)(globalContext.recordContext, markerContext);
        },
        setContext: () => {
            onceInit();
            globalContext.recordContext = (0, Bit_1.getSetBitValue)(globalContext.recordContext, markerContext);
        },
        removeContext: () => {
            if (!(0, utils_1.isNumber)(markerContext)) {
                return;
            }
            globalContext.recordContext = (0, Bit_1.getDelBitValue)(globalContext.recordContext, markerContext);
        },
    };
};
exports.registerContext = registerContext;
//# sourceMappingURL=general.js.map